import { Routes, Route, BrowserRouter } from 'react-router-dom';
import LIFFHome from './Page/LIFFHome';
import About from './Page/About';
import Video from './Page/Video';
import FontShow from './Page/FontShow';
import FontShow3 from './Page/FontShow3';
import Calendar from './Page/Calendar';
import FormGatekeeper from './Page/FormGatekeeper';

import SlideDigitalReception from './Page/SlideDigitalReception';
import SlideDigitalSaveLocal from './Page/SlideDigitalSaveLocal';
import Reconfirm from './Page/Reconfirm';
import AdminDashboard from './Page/AdminDashboard';

function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/albumdigital" element={<LIFFHome params="albumdigital" />} />
          <Route path="/slidedigital" element={<LIFFHome params="slidedigital" />} />
          
          <Route path="/calendar" element={<Calendar />} />
          <Route path="/about" element={<About />} />
          <Route path="/video" element={<Video />} />
          <Route path="/fontshow" element={<FontShow />} />
          <Route path="/font" element={<FontShow3 />} />
          
          <Route path="/gatekeeper" element={<FormGatekeeper mode="new" />} />
          <Route path="/editgatekeeper" element={<FormGatekeeper mode="edit" />} />

          <Route path="/slidedigitalreception" element={<SlideDigitalReception />} />
          <Route path="/slidedigitalsave_local" element={<SlideDigitalSaveLocal />} />
          
          <Route path="/reconfirm" element={<Reconfirm />} />
          <Route path="/admindashboard" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
